/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Oversight_Ack_LabelInputs */

const en_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const de_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich verstehe, dass diese Bewertung KI-gestützt ist, und ich werde sie prüfen, bevor ich darauf reagiere.`)
};

const fr_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const es_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const it_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const nl_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const pl_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const fi_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const da_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

const sv_deep_match_oversight_ack_label = /** @type {(inputs: Deep_Match_Oversight_Ack_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I understand this score is AI-assisted and I will review it before acting on it.`)
};

/**
* | output |
* | --- |
* | "I understand this score is AI-assisted and I will review it before acting on it." |
*
* @param {Deep_Match_Oversight_Ack_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_oversight_ack_label = /** @type {((inputs?: Deep_Match_Oversight_Ack_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Oversight_Ack_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_oversight_ack_label(inputs)
	if (locale === "fr") return fr_deep_match_oversight_ack_label(inputs)
	if (locale === "es") return es_deep_match_oversight_ack_label(inputs)
	if (locale === "it") return it_deep_match_oversight_ack_label(inputs)
	if (locale === "nl") return nl_deep_match_oversight_ack_label(inputs)
	if (locale === "pl") return pl_deep_match_oversight_ack_label(inputs)
	if (locale === "fi") return fi_deep_match_oversight_ack_label(inputs)
	if (locale === "da") return da_deep_match_oversight_ack_label(inputs)
	if (locale === "sv") return sv_deep_match_oversight_ack_label(inputs)
	return en_deep_match_oversight_ack_label(inputs)
});